import { useState } from 'react';
import {
  useHeaUpdateModuleMutation,
  useHeaDeleteModuleMutation,
  ExtendedHeaUnitFragmentDoc,
  HeaLesson
} from '@api/graphql-codegen';
import { useEditUnit } from '../useEditUnit';
import { ExtendedContent, ContentType } from '@types';
import { logger } from '../../../../../utils/logger';

interface useHeaModuleCRUDProps {
  heaGroups: ExtendedContent[];
  clearFile: () => void;
  activeTab: string;
  currentTabContent?: ExtendedContent;
  onChangeData: (v: string | null) => void;
  onChangeGroupTabs: (v: ExtendedContent[]) => void;
};

export const useHeaModuleCRUD = ({ heaGroups, activeTab, clearFile, currentTabContent, onChangeData, onChangeGroupTabs }: useHeaModuleCRUDProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { lesson, setSelectionLevel, heaUnit, setHeaUnit } = useEditUnit();

  const [updateHeaModule] = useHeaUpdateModuleMutation({
    onError(e) {
      logger.debug(`[e]`, e);
      setLoading(false);
    },
    update(cache, result, { variables }) {
      const d = variables?.input;
      if (!!d && result?.data?.heaUpdateModule) {
        const newArray = [...heaGroups];
        const index = newArray.findIndex(content => content.groupName === activeTab);
        if (index > -1) {
          newArray[index] = { ...newArray[index], ...d, type: newArray[index].type };
          onChangeGroupTabs(newArray);
        }
        // if (d.type !== ContentType.FORM) {
        //   onChangeData(d?.data ?? '');
        // }

        clearFile();
        if (heaUnit) {
          if (lesson?.id) {
            const classPresentation = [...(heaUnit.classPresentation || [])]
            const lessonIndex = classPresentation.findIndex(m => m?.originalLessonId === lesson?.id);
            if (lessonIndex > -1) {
              const selectedLesson = classPresentation[lessonIndex];
              const modules = [...(selectedLesson?.modules || [])];
              const moduleIndex = modules.findIndex(m => m?.id === d?.id);
              if (moduleIndex > -1) {
                modules[moduleIndex] = { ...d, type: d.type! };
              }
              classPresentation[lessonIndex] = {...selectedLesson, modules} as HeaLesson;
            }
            // setHeaUnit({...heaUnit, classPresentation});
            cache.updateFragment({
              id: `HeaUnit:${heaUnit?.id}`,
              fragment: ExtendedHeaUnitFragmentDoc,
              fragmentName: 'ExtendedHEAUnit'
            }, (data) =>({
              ...data,
              classPresentation,
            }));
          } else {
            const parentPreparation = [...(heaUnit.parentPreparation || [])]
            const index = parentPreparation.findIndex(m => m?.id === d?.id);
            if (index > -1) {
              parentPreparation[index] = { ...d, type: d.type as ContentType };;
            }
            // setHeaUnit({...heaUnit, parentPreparation});
            cache.updateFragment({
              id: `HeaUnit:${heaUnit?.id}`,
              fragment: ExtendedHeaUnitFragmentDoc,
              fragmentName: 'ExtendedHEAUnit'
            }, (data) =>({
              ...data,
              parentPreparation,
            }));
          }
        }
      }
      setLoading(false);
    }
  });

  const [deleteHeaModule, { loading: isHeaModuleRemoving }] = useHeaDeleteModuleMutation({
    update(_cache, res) {
      setLoading(false);
      if (res.data?.heaDeleteModule) {
        if (heaUnit) {
            const parentPreparation = [...(heaUnit.parentPreparation || [])];
            const index = parentPreparation.findIndex(m => m?.id === currentTabContent?.id);
            if (index > -1) {
              parentPreparation.splice(index, 1);
            }
            setHeaUnit({...heaUnit, parentPreparation});
            _cache.updateFragment({
              id: `HeaUnit:${heaUnit?.id}`,
              fragment: ExtendedHeaUnitFragmentDoc,
              fragmentName: 'ExtendedHEAUnit'
            }, (data) =>({
              ...data,
              parentPreparation,
            }));
        }
      }
    },
    onCompleted() {
      setSelectionLevel('Unit');
    },
    onError(e) {
      setLoading(false);
      logger.info({ e });
    },
  })

  return {
    updateHeaModule,
    deleteHeaModule,
    isHeaModuleRemoving,
    loading
  }
};
